"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductBox = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _productBox = require("@ori/product-box");
const ProductBox = exports.ProductBox = (0, _mui.styled)(_productBox.ProductBox, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'isSingleOffer'
    ])
})((param)=>{
    let { isSingleOffer, theme } = param;
    return {
        ...isSingleOffer && {
            width: 165
        },
        [theme.breakpoints.up('sm')]: {
            ...isSingleOffer && {
                width: 234
            }
        }
    };
});
